import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/axios'
import './plugins/bootstrap-vue'
import App from '../src/pages/about_us.vue'
import './plugins/element.js'
import store from './store'
import 'swiper/dist/css/swiper.css'
import 'swiper/dist/js/swiper.min'
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap,{ak:'EMrypSQBeUEGhmFZr4cvBweFz2I2deOj'}) // ak来源：17637926780账号

Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
